/**
 * useMediumEntryScreen.js
 * -----------------------
 * Hook for Medium create/edit form screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as mediumApi from '../api/mediumApi';

export function useMediumEntryScreen() {
  return useMasterEntry({
    entityName: 'Medium',
    apiClient: mediumApi.mediumClient,
    fetchDetail: mediumApi.getMediumDetail,
    createItem: mediumApi.createMedium,
    updateItem: mediumApi.updateMedium,
    initialForm: {
      name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Medium Name is required.';
      }
      return null;
    },
    listPath: '/masters/medium/list',
  });
}
